function firstNonEmpty(...values) {
    for (const value of values) {
        if (value != null && String(value).trim() !== '') {
            return String(value).trim();
        }
    }

    return '';
}

export function resolveFastOrderCode(query = {}) {
    return firstNonEmpty(
        query.code,
        query.couponCode,
        query.couponcode,
        query.coupon,
        query.referral
    );
}

export function toCanonicalFastOrderQuery(query = {}) {
    const nextQuery = { ...query };
    const code = resolveFastOrderCode(nextQuery);

    delete nextQuery.couponCode;
    delete nextQuery.couponcode;
    delete nextQuery.coupon;
    delete nextQuery.referral;
    delete nextQuery.couponType;
    delete nextQuery.coupontype;
    delete nextQuery.type;

    if (code) {
        nextQuery.code = code;
    } else {
        delete nextQuery.code;
    }

    return nextQuery;
}
